// extracted by mini-css-extract-plugin
export default {"root":"InspectionService-root","title":"InspectionService-title","image":"InspectionService-image","icon":"InspectionService-icon","promo":"InspectionService-promo"};